import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {onReject} from '../handler'
import type {Modals, ModalState} from './entities'
import {hideModalThunk} from './thunk'

const initialState: ModalState = {
  modal: {
    type: 'None',
    props: {},
  },
  status: 'close',
}

const modal = createSlice({
  name: 'modal',
  initialState: initialState,
  reducers: {
    showModal: (state, action: PayloadAction<Modals>) => {
      state = {
        modal: action.payload,
        status: 'open',
      }
      return state
    },
    closeModal: (state) => {
      state = initialState
      return state
    },
    hideModal: (state) => {
      state.status = 'close'
      return state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(hideModalThunk.fulfilled, (state) => {
      return state
    })
    builder.addCase(hideModalThunk.rejected, (state, action) => {
      onReject(action.payload)
    })
  },
})

export const {
    showModal,
    hideModal,
    closeModal,
} = modal.actions

export default modal.reducer
